import React from "react";
import styled from "styled-components";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "./Footer";

export default function PaymentFailure() {
  return (
   <>
   <TopNavbar/>
   <br/>
   <br/>
   <br/>
    <FailWrapper>
      <h2>❌ Payment Failed</h2>
      <p>We couldn’t complete your payment. Please try again or contact support.</p>
    </FailWrapper>

   <Footer/>
   </>
  );
}

const FailWrapper = styled.div`
  padding: 60px 20px;
  max-width: 600px;
  margin: auto;
  text-align: center;
  margin:50px;
  margin-left:70px;
  h2 {
    color: red;
    margin-bottom: 20px;
  }
`;